<template>
  <div class="p-4">
    <!-- Кнопка "Добавить пользователя" -->
    <button
      v-can-write="'users'"
      @click="openAddUserModal"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
    >
      Добавить пользователя
    </button>

    <!-- Состояние загрузки -->
    <div v-if="loading" class="flex justify-center items-center h-40">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <!-- Таблица пользователей -->
    <table v-else class="w-full border-collapse bg-white shadow-md">
      <thead class="bg-gray-100">
      <tr>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">ID</th>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Логин</th>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Email</th>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Роль</th>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Действия</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users" :key="user.id" class="border-b hover:bg-gray-50">
        <td class="px-4 py-2 text-sm text-gray-700">{{ user.id }}</td>
        <td class="px-4 py-2 text-sm text-gray-700">{{ user.name }}</td>
        <td class="px-4 py-2 text-sm text-gray-700">{{ user.email }}</td>
        <td class="px-4 py-2 text-sm text-gray-700">{{ user.role.name }}</td>
        <td class="px-4 py-2 space-x-2">
          <button
            v-can-write="'users'"
            @click="openEditUserModal(user)"
            class="px-2 py-1 text-sm font-medium text-blue-600 bg-blue-100 rounded-md hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Редактировать
          </button>
          <button
            v-can-write="'users'"
            @click="confirmDelete(user.id)"
            class="px-2 py-1 text-sm font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Удалить
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- Модальное окно для добавления/редактирования пользователя -->
    <AddOrEditUserModal ref="addUserModal" @user-updated="getUsers"></AddOrEditUserModal>

    <!-- Модальное окно подтверждения удаления -->
    <div v-if="isConfirmModalVisible"
         class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
        <h2 class="text-lg font-bold mb-4">Подтвердите удаление</h2>
        <p class="text-sm text-gray-700 mb-4">Вы уверены, что хотите удалить этого пользователя?</p>
        <div class="flex justify-end space-x-2">
          <button
            @click="cancelDelete"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Отмена
          </button>
          <button
            @click="proceedDelete"
            class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddOrEditUserModal from '@/components/user/AddOrEditUserModal.vue';

export default {
  components: {AddOrEditUserModal},
  data() {
    return {
      users: [], // Список пользователей
      loading: true, // Флаг загрузки
      isConfirmModalVisible: false, // Флаг видимости модального окна подтверждения
      userIdToDelete: null, // ID пользователя для удаления
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      axios
        .post('/api/user/getUsers')
        .then((response) => {
          console.log(response.data.data);
          this.users = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    confirmDelete(id) {
      this.userIdToDelete = id; // Сохраняем ID пользователя
      this.isConfirmModalVisible = true; // Показываем модальное окно
    },
    cancelDelete() {
      this.isConfirmModalVisible = false; // Скрываем модальное окно
      this.userIdToDelete = null; // Очищаем ID
    },
    proceedDelete() {
      if (!this.userIdToDelete) {
        console.error('ID пользователя не указан');
        return;
      }
      axios
        .post('/api/user/deleteUser', {id: this.userIdToDelete})
        .then(() => {
          this.getUsers(); // Обновляем список пользователей
          this.cancelDelete(); // Скрываем модальное окно
        })
        .catch((error) => {
          console.error(error);
        });
    },
    openAddUserModal() {
      if (!this.$refs.addUserModal) {
        return;
      }
      this.$refs.addUserModal.show(); // Открываем модальное окно для создания
    },
    openEditUserModal(user) {
      if (!this.$refs.addUserModal) {
        return;
      }
      this.$refs.addUserModal.show(user); // Передаем данные пользователя
    }
  },
};
</script>
